module.exports = __webpack_public_path__ + "img/rootopeninactive.7dd2e4cf.svg";